import { render, staticRenderFns } from "./DataTree.vue?vue&type=template&id=1061389e&"
import script from "./DataTree.vue?vue&type=script&lang=js&"
export * from "./DataTree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports